/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Transaction_FailedInputs */

const en_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The deposit didn’t go through. Try again.`)
};

const de_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Einzahlung ist nicht durchgegangen. Versuchen Sie es erneut.`)
};

const pt_br2_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O depósito não foi concluído. Tente novamente.`)
};

const tr_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para yatırma işlemi gerçekleşmedi. Tekrar deneyin.`)
};

const zh_cn2_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本次存入未成功，请重试。`)
};

const zh_hk2_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今次存入未能完成，請再試一次。`)
};

const ko_kr2_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금이 완료되지 않았습니다. 다시 시도해 주세요.`)
};

const ru_ru2_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пополнение не прошло. Попробуйте ещё раз.`)
};

const es_419_deposit_error_transaction_failed = /** @type {(inputs: Deposit_Error_Transaction_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El depósito no se completó. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "The deposit didn’t go through. Try again." |
*
* @param {Deposit_Error_Transaction_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_transaction_failed = /** @type {((inputs?: Deposit_Error_Transaction_FailedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Transaction_FailedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_transaction_failed(inputs)
	if (locale === "de") return de_deposit_error_transaction_failed(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_transaction_failed(inputs)
	if (locale === "tr") return tr_deposit_error_transaction_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_transaction_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_transaction_failed(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_transaction_failed(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_transaction_failed(inputs)
	return es_419_deposit_error_transaction_failed(inputs)
});